import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@workspace/public-utils'

interface PublicAnnouncement {
  id: string
  title: string
  announcement_type: string
  status: string
  target_user_roles: string[]
}

interface PublicAnnouncementsResponse {
  announcements: PublicAnnouncement[]
  total: number
}

export function useBannerAnnouncements() {
  return useQuery({
    queryKey: ['lottomd', 'banner-announcements'],
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<PublicAnnouncementsResponse>(
        '/api/v1/public/announcements',
        { signal, params: { active_only: true } },
      )
      return data.announcements.filter(
        (item) =>
          item.announcement_type === 'banner' &&
          item.status === 'active' &&
          item.target_user_roles.includes('customer'),
      )
    },
  })
}
